(function () {
    function checkDesignMode() {
        return (window.Shopify && window.Shopify.designMode) ||
            document.querySelector('shopify-editor-interface-shadow-dom');
    }

    function applyRtlFix() {
        if (checkDesignMode()) {
            const html = document.documentElement;
            // 1. LTR Root Pattern & Scrollbar Suppression
            //html.style.setProperty('direction', 'ltr', 'important');
            html.style.setProperty('scrollbar-width', 'none', 'important'); // Firefox
            html.style.setProperty('-ms-overflow-style', 'none', 'important'); // IE/Edge

            // 2. Webkit Scrollbar Suppression (Inject Style)
            if (!document.getElementById('megartl-editor-styles')) {
                const style = document.createElement('style');
                style.id = 'megartl-editor-styles';
                style.textContent = 'html::-webkit-scrollbar { width: 0 !important; height: 0 !important; }';
                // Append to head if possible, else html
                (document.head || html).appendChild(style);
            }

            // 3. Body Restoration (if body exists yet)
            if (document.body) {
                // No need to force !important here, as body should inherit from html
                //document.body.style.setProperty('direction', 'rtl', 'important');
            }

            // Diagnostic Log
            const leftOffset = html.getBoundingClientRect().left;
        }
    }

    // Apply immediately
    applyRtlFix();

    // Continuous enforcement
    const observer = new MutationObserver((mutations) => {
        let recheck = false;

        for (const mutation of mutations) {
            // 1. Watch for new nodes (detecting editor load)
            if (mutation.type === 'childList') {
                recheck = true;
            }
            // 2. Watch for style overrides by the Editor on HTML or BODY
            else if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                // Only re-apply if the style is actually wrong (prevents infinite loop)
                if (checkDesignMode()) { // only relevant in design mode
                    const target = mutation.target;
                    const dir = target.style.getPropertyValue('direction');
                    if (target === document.documentElement && dir !== 'ltr') recheck = true;
                    if (target === document.body && dir !== 'rtl') recheck = true;
                }
            }
        }

        if (recheck) applyRtlFix();
    });

    // Watch for:
    // 1. Element injection (subtree: true, childList: true)
    // 2. Style tampering on HTML/BODY (attributes: true)
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
    });
    // Note: HTML observer covers body for subtree, but attributes need explicit logic or bubbling?
    // Attributes don't bubble. We need to observe body separately for attributes if we want to be strict,
    // OR rely on the fact that any DOM shift usually triggers enough noise.
    // Better: Observe body specifically for attributes once it exists.
    if (document.body) {
        observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });
    }
    else {
        // If body intentionally lazy, catch it in childList
        window.addEventListener('DOMContentLoaded', () => {
            observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });
            applyRtlFix();
        });
    }
})();
